import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

import { AllInOneUserRepository } from '../infra/AllInOneUserRepository'

export function saveAllInOneToken(token: string) {
  const storage = new LocalStorageClient()
  const repository = new AllInOneUserRepository({ storage })

  repository.setLocalToken(token)
}
